export default __webpack_public_path__ + "static/media/miguel-lopes-31.ce02487a.jpg";